<mat-toolbar class="header">
  <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div class="hide-print" >
    @if (work){
      Trabajo: {{work?.work?.name || 'Otros'}}
    }@else{
      Cargando...
    }
  </div>

</mat-toolbar>

@if (!work) {
  <div class="skeleton-container">
    <div class="skeleton" style="height: 98px;"></div>
    <div class="skeleton" style="height: 123px;"></div>
    <div class="skeleton" style="height: 170px;"></div>
    <div class="skeleton" style="height:  74px;"></div>
    <div class="skeleton" style="height:  90px;"></div>
  </div>
}

<div class="dialog-wrapper">
  <div *ngIf="work" #wrapper>
    <div class="info" style="margin-bottom: 1em">
      @if (work.document && work.document.object) {
        <div class="name">{{appService.getText('object_identifier')}}</div>
        <div class="value">{{work.document?.object?.identifier || 'Sin '+appService.getText('object_identifier')}}</div>
      }
      @if (work.document && work.document.vehicle) {
        <div class="name">{{appService.getText('object_identifier')}}</div>
        <div class="value">{{work.document?.vehicle?.identifier || 'Sin '+appService.getText('object_identifier')}}</div>
      }
        <div class="name">Creacion</div>
        <div class="value">{{work.created_at | date:'shortDate'}}</div>
        <div class="name">{{appService.getText('requirement')}}</div>
        <div class="value">{{work.document?.requirement?.name || 'Sin '+appService.getText('requirement')}}</div>

        <div class="name">Asignado</div>
        <div class="value">
          @if (!work.completed_at && (canUpdateWork() | async) === true) {
            <mat-chip (click)="setUser($event, {id: work.id, roles_id: work.work.roles_id})" matTooltip="Cambiar Asignado">
              <span class="work-user-chip">
                {{work.user?.name || '-'}}
                <mat-icon>swap_horiz</mat-icon>
              </span>
            </mat-chip>
          } @else {
            <span>{{work.user?.name || '-'}}</span>
          }
        </div>

      @if (work.sign_url) {
        <div class="name">Firma</div>
        <div class="value"><img src="{{work.sign_url}}" style="max-height: 100px"/></div>
      }

      @if (work.name) {
        <div class="name"><b>{{work.requester?.name}}</b></div>
        <div class="value">{{work.name}}</div>
      }
    </div>

    <div class="form-container" *ngIf="work && work.check_list">
      <div class="checklist">

          <div class="subtitle">Listado de Trabajo - {{work.check_list.name}}</div>
          <div class="list">
            <div class="row">
              <div class="col">
                <div class="check" *ngFor="let item of work.work_statuses; let i = index">
                  <ng-container *ngIf="work.check_list.check_list_type === 'check'">
                    <mat-checkbox [disabled]="work.completed_at" [(ngModel)]="item.completed" (ngModelChange)="toggle(item)" [disabled]="waitingRevision()">{{getCheckListName(item.check_list_item_id)}}</mat-checkbox>
                  </ng-container>
                  <ng-container *ngIf="work.check_list.check_list_type === 'radio'">
                    <mat-radio-group [(ngModel)]="item.value" (ngModelChange)="toggle(item)" [disabled]="work.completed_at || waitingRevision()" class="radio-group">
                      <mat-radio-button [value]=2 class="radio-green" ></mat-radio-button>
                      <mat-radio-button [value]=1 class="radio-yellow" ></mat-radio-button>
                      <mat-radio-button [value]=0 class="radio-red" ></mat-radio-button>
                    </mat-radio-group>
                    <div class="text">{{getCheckListName(item.check_list_item_id)}}</div>
                  </ng-container>
                  <ng-container *ngIf="work.check_list.check_list_type === 'boolean'">
                    <mat-radio-group [(ngModel)]="item.value" (ngModelChange)="toggle(item)" [disabled]="work.completed_at || waitingRevision()" class="radio-group">
                      <mat-radio-button [value]=2 class="radio-green" ></mat-radio-button>
                      <mat-radio-button [value]=0 class="radio-red" ></mat-radio-button>
                    </mat-radio-group>
                    <div class="text">{{getCheckListName(item.check_list_item_id)}}</div>
                  </ng-container>
                </div>
              </div>
              <div class="col revision" *ngIf="work && work.work && work.work.require_revision && (isRevisor() || work.last_revisor_id)">
                <div class="checklist">
                  <div class="check" *ngFor="let item of work.work_statuses; let i = index">
                    <ng-container *ngIf="work.check_list.check_list_type === 'check'">
                      <mat-checkbox [disabled]="work.completed_at" [(ngModel)]="item.revision_completed" (ngModelChange)="toggle(item)" [disabled]="!isRevisor()">{{getCheckListName(item.check_list_item_id)}}</mat-checkbox>
                    </ng-container>
                    <ng-container *ngIf="work.check_list.check_list_type === 'radio'">
                      <mat-radio-group [(ngModel)]="item.revision_value" (ngModelChange)="toggle(item)" [disabled]="work.completed_at || !isRevisor()" class="radio-group">
                        <mat-radio-button [value]=2 class="radio-green" ></mat-radio-button>
                        <mat-radio-button [value]=1 class="radio-yellow" ></mat-radio-button>
                        <mat-radio-button [value]=0 class="radio-red" ></mat-radio-button>
                      </mat-radio-group>
                      <div class="text">{{getCheckListName(item.check_list_item_id)}}</div>
                    </ng-container>
                    <ng-container *ngIf="work.check_list.check_list_type === 'boolean'">
                      <mat-radio-group [(ngModel)]="item.revision_value" (ngModelChange)="toggle(item)" [disabled]="work.completed_at || !isRevisor()" class="radio-group">
                        <mat-radio-button [value]=2 class="radio-green" ></mat-radio-button>
                        <mat-radio-button [value]=0 class="radio-red" ></mat-radio-button>
                      </mat-radio-group>
                      <div class="text">{{getCheckListName(item.check_list_item_id)}}</div>
                    </ng-container>
                  </div>
                </div>
                <div class="score">
                  <div class="title">Puntaje</div>
                  <div class="number">{{calcPoints(work.work_statuses,work.check_list.check_list_type)}}%</div>
                  <div class="title">Revisión</div>
                </div>
              </div>
            </div>
            <div class="check empty" *ngIf="!work.user_id">Debes asignar un usuario para poder completar</div>
            <div class="check empty" *ngIf="(!work.work_statuses || work.work_statuses.length == 0) && work.user_id">No hay puntos a completar</div>
          </div>

      </div>
    </div>

    <div class="form-container images-container">
      <div class="subtitle" style="margin-bottom: 10px;">Adjuntar fotos del {{appService.getText('work_assignation')}}</div>
      <app-image-uploader
        [gallery]="getGallery()"
        [photos]="work.pictures"
        [small]="true"
        [scrollTarget]="wrapper"
        (uploaded)="saveImages($event)"
        [readonly]="clientMode"
        [placeholders]="placeholders"
        
        >
      </app-image-uploader>
      <div class="subtitle error" *ngIf="work.work && this.work.work.min_photos > work.pictures.length || hasPendingPlaceholder"><i class="fa fa-exclamation-triangle"></i>Faltan imágenes ({{getPendingImages()}})</div>
    </div>
    @if (work.work && work.work.custom_response_type!=="none") {
      <div class="form-container">
        @if (work.budget_id || work.work.custom_response_type === 'budget') {
          <wpl-budget-work [parentForm]="form" [value]="work"></wpl-budget-work>
        } @else if(work.work.custom_response_type === 'inventory_action_for_pricing') {
          <wpl-inventory-action-for-pricing [workInstance]="work"></wpl-inventory-action-for-pricing>
        } @else if(work.work.custom_response_type === 'create_document') {
          <wpl-create-document [workInstance]="work" (actionButtons)="actionButtons.set($event)"></wpl-create-document>
        } @else if(work.work.custom_response_type === 'edit_document') {
          <wpl-edit-document [workInstance]="work"></wpl-edit-document>
        }
        <app-order-fields mode="Work" [model]="work" [parentFormGroup]="form" [reactiveFormMode]="true" [clientMode]="clientMode" [disabled]="work.completed_at" [filterFields]="filterCustom"></app-order-fields>
        <ng-template [ngIf]="work && work.work && work.work_request && work.work_request.work && work.work_request.custom_params && !clientMode && work.user_id">
          <div class="subtitle">&nbsp;&nbsp;<i class="fa fa-clock"></i>&nbsp;&nbsp; Trabajo Previo: {{work.work_request?.work?.name}}<div class="expander"></div>
            <button mat-button (click)="cloneData()"><i class="fa fa-copy" *ngIf="work.work.custom_response_type === work.work_request.work.custom_response_type && !work.completed_at"></i></button>
          </div>
          <wpl-custom-params class="custom_params" [workRequest]="work.work_request" [clientMode]="clientMode ">
          </wpl-custom-params>
        </ng-template>
        <wpl-custom-params class="custom_params" *ngIf="work && work.work && work.user_id" [workRequest]="work" [parentForm]="form"  [clientMode]="clientMode">
        </wpl-custom-params>
      </div>
    }
    <ng-container *ngIf="!clientMode">
      <div class="comments-container" (click)="goToComments()">
        <div class="comments-header">
          <div class="subtitle hide-print">Bitácora</div>
          <mat-icon *ngIf="!loadingChat()" class="icon-primary">chat</mat-icon>
        </div>
        <div>
          <span>¡Ahora puedes ver los mensajes de la bitácora directamente en el chat de la orden! Haz clic aquí para acceder.</span>
        </div>
        <mat-progress-spinner *ngIf="loadingChat()" mode="indeterminate" diameter="20"></mat-progress-spinner>
      </div>
    </ng-container>

  </div>
</div>

@if (work && !clientMode) {
<div>
  <app-work-dialog-footer
    [actionButtons]="actionButtons()"
    [clientMode]="clientMode"
    [chatMode]="chatMode"
    [form]="form"
    [hasPendingPlaceholder]="hasPendingPlaceholder"
    [isReadOnly]="readOnly"
    [isRevisor]="isRevisor()"
    [waitingRevision]="waitingRevision()"
    [work]="work"
    >
  </app-work-dialog-footer>
</div>
}